// @flow
import useIntegration from 'hooks/useIntegration'
import * as React from 'react'
import type { Question } from 'types/question'
import type { QuestionChoice } from 'types/question-choice'
import Flex from 'ui/atoms/Flex'
import Icon, { IconSources } from 'ui/atoms/Icon'
import Text from 'ui/atoms/Text'

import Tooltip from '../../../ui/atoms/Tooltip.jsx'
import BuilderCheckboxEditPropsContent from './BuilderCheckboxEditPropsContent'
import BuilderCheckboxEditPropsModal from './BuilderCheckboxEditPropsModal'

type QuestionProps = {
  question_choices?: Array<QuestionChoice>,
  default_value?: ?string,
  min_value?: ?number,
  max_value?: ?number,
}

type Props = {
  question: Question,
  questionId: number,
  onUpdateQuestionProps: (props: QuestionProps) => void,
  mayRequestDetails?: boolean,
  assignValues?: boolean,
}

export function BuilderCheckboxEditProps({
  questionId,
  question,
  onUpdateQuestionProps,
  mayRequestDetails,
  assignValues,
}: Props): React.Node {
  const { integration } = useIntegration()
  const [modalOpen, setModalOpen] = React.useState(false)

  return (
    <div className="flex flex-col">
      <Flex $horizontalSpacing="small" className="mb-1">
        <Text $semibold>Choices</Text>
        {!!integration && (
          <Tooltip label="View Integration Values" mouseEnterDelay={0.3}>
            <span className="flex h-6 items-center justify-center">
              <Icon
                name={IconSources.ARROW_UP_RIGHT}
                onClick={() => setModalOpen(true)}
              />
            </span>
          </Tooltip>
        )}
      </Flex>
      <BuilderCheckboxEditPropsContent
        assignValues={assignValues}
        mayRequestDetails={mayRequestDetails}
        onUpdateQuestionProps={onUpdateQuestionProps}
        question={question}
        questionId={questionId}
      />
      {modalOpen && (
        <BuilderCheckboxEditPropsModal
          assignValues={assignValues}
          mayRequestDetails={mayRequestDetails}
          onHide={() => setModalOpen(false)}
          onUpdateQuestionProps={onUpdateQuestionProps}
          question={question}
          questionId={questionId}
        />
      )}
    </div>
  )
}

export default BuilderCheckboxEditProps
